<template>
  <div :class="[`view-337`, className || ``]">
    <x62 />
    <div class="group-495-2">
      <div class="group-490-2">
        <view40 />
        <notification-alarm-bell-svgrepo-com1 />
        <img
          class="vector-226"
          src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-64.svg"
          alt="Vector"
        />
        <view41 />
        <div class="text-374 poppins-normal-chicago-17px">Главная</div>
        <house-fill-svgrepo-com1 :className="houseFillSvgrepoCom1Props.className" />
      </div>
      <group491 />
    </div>
  </div>
</template>

<script>
import X62 from "./X62";
import View40 from "./View40";
import NotificationAlarmBellSvgrepoCom1 from "./NotificationAlarmBellSvgrepoCom1";
import View41 from "./View41";
import HouseFillSvgrepoCom1 from "./HouseFillSvgrepoCom1";
import Group491 from "./Group491";
export default {
  name: "View30",
  components: {
    X62,
    View40,
    NotificationAlarmBellSvgrepoCom1,
    View41,
    HouseFillSvgrepoCom1,
    Group491,
  },
  props: ["className", "houseFillSvgrepoCom1Props"],
};
</script>

<style>
.view-337 {
  display: flex;
  gap: 300px;
  height: 54px;
  position: relative;
  width: 1319px;
}

.group-495-2 {
  display: flex;
  gap: 36px;
  height: 50px;
  margin-top: 2px;
  position: relative;
  width: 920px;
}

.group-490-2 {
  height: 34px;
  margin-top: 8px;
  position: relative;
  width: 756px;
}

.vector-226 {
  aspect-ratio: 1;
  height: 26px;
  left: 23.68%;
  position: absolute;
  top: calc(50% - 13px);
  width: 3.44%;
}

.text-374 {
  left: 37px;
  letter-spacing: 0.34px;
  line-height: normal;
  position: absolute;
  top: 5px;
}

.view-337.view-343,
.view-337.view-346,
.view-337.view-347 {
  left: 308px;
  position: absolute;
  top: 6px;
}
</style>
